var OCS = OCS || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Classes = OCS.Advisories.Classes || {};
OCS.Advisories.Functions = OCS.Advisories.Functions || {};
OCS.Advisories.Functions.define_AdvisoryDataEvent_class = function (in_implements) {
    var implements = [Options];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }    
    return new Class({
        Implements: implements,
        class_type: "AdvisoryDataEvent",
        class_name: "AdvisoryDataEvent",
        options: {
            action: '',
            beginning_time: 0,
            ending_time: 0,
            etn: "0000",
            file: '',
            issued_time: 0,
            nwso: '',
            phenom: '',
            significance: '',
            zone: []
        },
        affects_all: true,
        geometry: {type: "Polygon", coordinates: []},
        initialize: function (op) {
            this.setOptions(op);
        },
        set_text: function (text) {
            this.options.text = text;
        },
        get_geom_event_key: function() {
            return this.options.nwso+"|"+this.options.phenom+"|"+this.options.significance+"|"+this.options.action+"|"+this.options.etn+"|"+this.options.beginning_time+"|"+this.options.ending_time+"|"+this.options.file;
        },
        get_properties: function () {
            return this.options;
        }
    });
};
OCS.Advisories.Classes.AdvisoryDataEvent = OCS.Advisories.Functions.define_AdvisoryDataEvent_class();
/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = {
            "init": OCS.Advisories.Functions.define_AdvisoryDataEvent_class
        };
    }
} catch (e) {

}